import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, CircularProgress, Chip } from "@mui/material";

const ORDERS_API = `${process.env.REACT_APP_SUPABASE_URL}/rest/v1/orders?select=*`;

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchOrders() {
      setLoading(true);
      setError("");
      try {
        // Auth required: get token from supabase client
        const token = window.localStorage.getItem("access_token");
        const res = await fetch(ORDERS_API, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (res.ok && Array.isArray(data)) {
          setOrders(data);
        } else {
          setError(data.error || "Failed to load orders.");
        }
      } catch (err) {
        setError("Failed to load orders.");
      }
      setLoading(false);
    }
    fetchOrders();
  }, []);

  if (loading) return <Box sx={{ textAlign: "center", mt: 4 }}><CircularProgress /></Box>;
  if (error) return <Box sx={{ textAlign: "center", mt: 4 }}><Typography color="error">{error}</Typography></Box>;

  return (
    <Box sx={{ maxWidth: 700, mx: "auto", mt: 4 }}>
      <Typography variant="h4" mb={3}>Your Orders</Typography>
      {orders.length === 0 ? (
        <Typography>No orders found.</Typography>
      ) : (
        orders.map(order => (
          <Paper key={order.id} sx={{ p: 2, mb: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Order #{order.id}</Typography>
              <Chip label={order.status} color={order.status === "paid" ? "success" : order.status === "draft" ? "warning" : order.status === "fulfilled" ? "primary" : "default"} />
            </Box>
            <Typography variant="body2" mb={1}>Total: ${(order.total_cents / 100).toFixed(2)}</Typography>
            {order.fulfillment_method && (
              <Typography variant="body2">Fulfillment: {order.fulfillment_method}</Typography>
            )}
            {order.requested_fulfillment_date && (
              <Typography variant="body2">Requested Date: {new Date(order.requested_fulfillment_date).toLocaleDateString()}</Typography>
            )}
            <Typography variant="body2" color="text.secondary">Created: {new Date(order.created_at).toLocaleString()}</Typography>
          </Paper>
        ))
      )}
    </Box>
  );
};

export default Orders;
